<template lang="pug">
include ../../plugins/pug/template
v-menu(v-model="isShowMenu" :close-on-content-click="false" :nudge-width="500" max-height="400" offset-y left transition="scroll-y-reverse-transition")
  template(v-slot:activator="{ on, attrs }")
    v-btn(icon v-bind="attrs" v-on="on").mr-4
      v-badge(dot overlap color="error" :value="!!notificationList.count")
        v-icon {{ setNotificationIcon }}

  v-card
    v-card-title.d-flex.align-center
      div {{ $t('notification.title') }}
      v-spacer
      +btn-icon-text-simple('primary', 'notification.readAll', '')(
        v-if="!!notificationList.count"
        small
        :loading="isLoadingReading"
        @click="readAll"
      )

    v-card-text
      v-slide-x-reverse-transition(group hide-on-leave)
        template(v-for="(item, index) in notificationList.results")
          v-list-item(
            :key="item.created_at"
            :active-class="`${notificationType[item.notification_type].color}--text`"
            @click="getNotificationDetail(item.id)"
          )
            v-list-item-avatar
              v-icon(:color="notificationType[item.notification_type].color" ) {{ notificationType[item.notification_type].icon }}

            v-list-item-content
              v-list-item-subtitle.caption.mb-1 {{ $moment(item.created_at).format('DD.MM.YYYY HH:mm') }}
              v-list-item-title.subtitle-2 {{ item.title }}

            v-list-item-action
              +btn-icon('', 'mdi-eye-outline', 'primary')(:loading="isLoadingDetail && item.id === selectedId")

          v-divider(
            v-if="index < notificationList.results.length - 1"
            :key="index"
          )

      v-dialog(v-model="isShowDialog" max-width="700" scrollable)
        v-card(:loading="!Object.keys(notification).length" v-if="isShowDialog" )
          v-card-text.pt-8(v-html="notification.text.replace(/(?:\\r\\n|\\r|\\n)/g, '<br />')")
          v-card-actions
            v-spacer
            +btn-icon-text-simple('primary', 'close')(@click="isShowDialog = false")

      div(v-if="!notificationList.count")
        div {{ $t('notification.empty') }}

    v-card-actions(v-if="notificationList.count > query.page_size")
      v-pagination(
        circle
        v-model="query.page"
        :length="Math.ceil(notificationList.count / query.page_size)"
        @input="changePage"
      )

</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'NotificationButton',
  data () {
    return {
      isShowMenu: false,
      isShowDialog: false,
      isLoadingDetail: false,
      isLoadingReading: false,
      selectedId: null,
      query: {
        page: 1,
        page_size: 20
      },
      notificationType: {
        1: {
          icon: 'mdi-information-outline',
          color: 'primary'
        },
        2: {
          icon: 'mdi-alert',
          color: 'warning'
        },
        3: {
          icon: 'mdi-alert-circle-outline',
          color: 'error'
        },
      }
    }
  },
  computed: {
    ...mapState({
      notificationList: state => state.notification.notificationList,
      notification: state => state.notification.notification
    }),
    setNotificationIcon () {
      return this.isShowMenu ? 'mdi-bell' : 'mdi-bell-outline'
    }
  },
  mounted () {
    this.getNotificationList(this.query)
  },
  methods: {
    ...mapActions(['getNotificationList', 'getNotification', 'readAllNotification']),
    async getNotificationDetail (id) {
      this.isLoadingDetail = true
      this.selectedId = id
      await this.getNotification(id)
      this.isLoadingDetail = false
      this.selectedId = null
      this.isShowDialog = true
    },
    async readAll () {
      this.isLoadingReading = true
      await this.readAllNotification()
      this.isLoadingReading = false
    },
    changePage (page) {
      this.query.page = page
      this.getNotificationList(this.query)
    }
  }
}

</script>